exports.ValidationCondition = [
  {
    id: "id",
    name: "id",
    type: "text",
    value: "",
    label: "Id",
    key: "true",
    length: 12,
  },
  {
    id: "universalDescriptor",
    name: "universalDescriptor",
    type: "text",
    value: "",
    label: "Universal Descriptor",
    key: "true",
    length: 12,
  },
  {
    id: "nameLocalizedText",
    name: "nameLocalizedText",
    type: "text",
    value: "",
    label: "nameLocalizedText",
  },
  {
    id: "type",
    name: "type",
    type: "text",
    value: "",
    label: "Type",
    length: 50,
  },
  {
    id: "initialStatusId",
    name: "initialStatusId",
    type: "text",
    value: "",
    label: "Initial Status Id",
    length: 12,
  },
  {
    id: "sentStatusId",
    name: "sentStatusId",
    type: "text",
    value: "",
    label: "Sent Status Id",
    length: 12,
  },
  {
    id: "errorStatusId",
    name: "errorStatusId",
    type: "text",
    value: "",
    label: "Error Status Id",
    length: 12,
  },
  {
    id: "openStatusId",
    name: "openStatusId",
    type: "text",
    value: "",
    label: "Open Status Id",
    length: 12,
  },

  {
    id: "createdBy",
    name: "createdBy",
    type: "text",
    label: "Created By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "createdOn",
    name: "createdOn",
    type: "datetime",
    label: "Created On",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedBy",
    name: "modifiedBy",
    type: "text",
    label: "Modified By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedOn",
    name: "modifiedOn",
    type: "datetime",
    label: "ModifiedOn",
    displayonly: "true",
    value: " ",
  },
  {
    id: "nameResourceKey",
    name: "nameResourceKey",
    type: "text",
    value: "",
    label: "nameResourceKey",
    hide: "true",
    displayonly: "true",
  },
];
